import { Moment } from 'moment';

import { BuildingBlockInputInterface } from './building-blocks/building-block.model';

export class Project {
    public banner: string;
    public buildingBlocks: Array<BuildingBlockInputInterface> = [];
    public color?: string;
    public description: string;
    public endDate: Moment;
    public image: string;
    public name: string;
    public slug: string;
    public startDate: Moment;
    public title: string;

    public constructor(config?: Project) {
        Object.assign(this, config);
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/project.model.ts